import { DownloadService } from '../utils/downloadService';

export const MaintenanceApi = {
    downloadPdf: maintenanceId => DownloadService.downloadAs(`/web/maintenances/${maintenanceId}/pdf`, 'maintenance_report.pdf'),
    downloadExcel: maintenanceId => DownloadService.downloadAs(`/web/maintenances/${maintenanceId}/excel`, 'maintenance_report.xlsx')
}
